import React from 'react';
import { motion } from 'framer-motion';

/**
 * AnimatedText — word-by-word reveal on scroll entry.
 * Usage: <AnimatedText as="h2" className="...">Your long headline</AnimatedText>
 */
const AnimatedText = ({
  children,
  as: Tag = 'h2',
  className = '',
  style = {},
  stagger = 0.06,
  duration = 0.7,
  y = 60,
  once = true,
}) => {
  const text = typeof children === 'string' ? children : '';
  const words = text.split(/(\s+)/); // keep whitespace

  const container = {
    hidden: {},
    show: {
      transition: { staggerChildren: stagger, delayChildren: 0.05 },
    },
  };
  const word = {
    hidden: { y, opacity: 0 },
    show: {
      y: 0,
      opacity: 1,
      transition: { duration, ease: [0.2, 0.65, 0.3, 0.9] },
    },
  };

  const MotionTag = motion[Tag] || motion.div;

  return (
    <MotionTag
      className={className}
      style={style}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once, margin: '-80px' }}
    >
      {words.map((w, i) =>
        /^\s+$/.test(w) ? (
          <span key={i}>{w}</span>
        ) : (
          <span
            key={i}
            className="inline-block overflow-hidden align-baseline"
            style={{ paddingBottom: '0.12em' }}
          >
            <motion.span className="inline-block" variants={word}>
              {w}
            </motion.span>
          </span>
        )
      )}
    </MotionTag>
  );
};

export default AnimatedText;
